import React, { useMemo } from "react";
import dayjs from "dayjs";
import { useMutation } from "@tanstack/react-query";
import { updateFiscalYear } from "api";
import { useNotify } from "hooks";
import { EsgDatePickerField } from "components";

export const FiscalMonthSelector = ({ configParameter }: { configParameter: any }) => {
  const notify = useNotify();

  const currentStartMonth = useMemo(() => dayjs(configParameter?.find((setting: any) => setting.name === "company_month_start")?.configValue, "MMM"), [configParameter]);

  const { mutateAsync: updateFiscalYearRequest } = useMutation(updateFiscalYear);

  const onMonthChange = (monthValue: any) => {
    const startMonthId = configParameter?.find((setting: any) => setting.name === "company_month_start")?.id as number;
    const endMonthId = configParameter?.find((setting: any) => setting.name === "company_month_end")?.id as number;
    const endMonth = dayjs(monthValue, "MMM").subtract(1, 'month').format("MMM");

    updateFiscalYearRequest([
      { id: startMonthId, value: monthValue },
      { id: endMonthId, value: endMonth },
    ]).then(() => {
      notify.success(`Your fiscal year has been updated to ${monthValue} - ${endMonth}!`);
    }).catch(() => {
      notify.error("Some error has happened while updating!");
    });
  };

  if (!configParameter) return null;

  return (
    <EsgDatePickerField
      width="240px"
      views={["month"]}
      format="MMM"
      openTo="month"
      disableHighlightToday
      onChange={(date: any) => {
        const monthValue = date ? date.format("MMM") : null;
        onMonthChange(monthValue);
      }}
      value={currentStartMonth}
      clearDate={false}
      label=""
    />
  )
}